import LegalPage from '@/components/legal/LegalPage';
import { COMPANY } from '@/config/company';

export default function Complaints() {
  return (
    <LegalPage
      title="Complaints Procedure"
      intro="How to raise a complaint with Quick Credit and what happens next."
      sections={[
        {
          heading: 'Step 1 — Tell us what went wrong',
          body: (
            <p>
              Contact us by email at {COMPANY.email}, by phone on {COMPANY.phone} during business hours, or
              in writing to {COMPANY.addressLine1}, {COMPANY.addressLine2}. Please include your name,
              contact details, account or application reference, what happened and how you would like it
              resolved.
            </p>
          ),
        },
        {
          heading: 'Step 2 — Acknowledgement',
          body: <p>We acknowledge every complaint within 3 business days and tell you who is handling it.</p>,
        },
        {
          heading: 'Step 3 — Investigation',
          body: <p>We investigate fairly and independently of the team involved. We may contact you for more information. Most complaints are resolved within 15 business days.</p>,
        },
        {
          heading: 'Step 4 — Our final response',
          body: <p>We send a written final response within 8 weeks explaining our findings, our decision and any remedy offered. If we need longer, we will tell you why.</p>,
        },
        {
          heading: 'If you are not satisfied',
          body: (
            <p>
              If you are unhappy with our final response, you may refer your complaint to the Consumer
              Financial Protection Bureau at consumerfinance.gov/complaint, or to your state financial
              regulator. Referring a complaint is free.
            </p>
          ),
        },
      ]}
    />
  );
}
